<template>
<div class="saved-card-payment" v-if="this.cards && this.buyNowMobile ? this.cards.length : false">
      <div class="row pt-2">
          <div class="col">
              <span style="float: left; padding-left: 1rem;color: #282c3f;">Saved Payment Options</span>
          </div>
      </div>
      <div class="address-cards d-flex flex-row">
          <div class="col-6 addCard mt-2 mb-3" :class="scard.card_token == isin ? 'addCard-active' : ''" v-for="(scard, index) in this.cards" v-bind:key="index" @click="setPayMethod('sc')">
              <label style="width:100%; margin-bottom: 0;" :for="scard.card_number" :class="{'active-tab': payopt === 'sc'}">
                <div class="col-3 pt-3 pb-2">
                    <div class="item99">
                        <img class="" :src="bankLogo[index].logo" v-if="bankLogo[index]" alt="Saved Card"/>
                    </div>
                </div>
                <div class="col-5 small pt-3 pb-2">
                    <span class="txtTruncate pb-1" style="color: black;"><b>{{scard.name_on_card}}</b></span>
                    <span style="color: black;">**** {{scard.card_number.substr(scard.card_number.length - 4)}}</span>
                </div>
                <div class="col-4 pt-2 pb-2">
                    <div class="col-12">
                        <svg v-show="scard.card_token == isin" style="height: 1rem; width: 1rem;float: right;">
                            <path xmlns="http://www.w3.org/2000/svg" id="check-mark" fill="#e2f8f8" d="M16 8a8 8 0 1 1-8-8 8 8 0 0 1 8 8z"/>
                            <path xmlns="http://www.w3.org/2000/svg" id="check-mark-2" fill="#148c8d" d="M11.536 5.462a.625.625 0 0 1 0 .884l-4.192 4.192a.625.625 0 0 1-.884 0l-2-2a.625.625 0 0 1 .884-.884L6.9 9.213l3.751-3.751a.625.625 0 0 1 .885 0zM16 8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-1.25 0A6.75 6.75 0 1 0 8 14.75 6.746 6.746 0 0 0 14.75 8zm0 0"/>
                        </svg>
                        <input :id="scard.card_number" class="collapsepadding" type="radio" name="radio" v-model="isin" :value="scard.card_token" @change="updatecardSelection(scard.card_number)">   
                    </div>
                    <div  class="col-12 pt-2 ml-2" v-show="scard.card_token == isin">
                        <input type="tel" class="btn btn-outline-info inputCvv2 cvvMask"
                        placeholder="CVV *" v-model="card[index].cvv" maxlength="4" :ref="`${scard.card_token}`"
                        @keydown="isNumber" @blur="CVVValidator" @focus="updateError('cvv', scard)" 
                        v-bind:class="{ error: error['cvv']['status'] }"
                        style="background-color:#fff; color:#464a4c;"/>
                    </div>
                </div>
              </label>
          </div>
      </div>
  </div>
  <div class="saved-cards-wrap" v-else>
    <div v-for="(scard, index) in this.cards" v-bind:key="index">
      <div class="card">
        <div class="" :class="{'active-tab': payopt === 'sc'}" style="background-color: #fff;">
          <label class="containor">
          <div class="cardwrap658 row">
          <div class="cardleft69 col-12">
              <div class="col-8">
                <div class="col-8">
                  <label :for="scard.card_number" class="darkfont txtTruncate pointer mb-0" style="font-size: 14px;">{{scard.card_issuer || 'Unknown Bank'}}</label>
                  <label :for="scard.card_number" class="txtTruncate pointer" style="font-size: 13px; color: #cccccc;">XXXX{{scard.card_number.substring(4)}}</label>
                </div>
                <div class="col-4 d-flex flex-column"
                  style="padding-right: 0 !important;padding-left: 0 !important;"
                >
                  <img class="paymentSprite-visa my-1 ml-auto" :src="bankLogo[index] ? bankLogo[index].logo : `${staticImg}savedcardlogo/unknown_logo.jpg`" alt="Saved Card"/>
                  <label :for="scard.card_number" class="item3 text-right txtTruncate pointer">{{scard.name_on_card}}</label>
                </div>
              </div>
              <div class="col-3">
                <div class="cardright69">
                  <div class="item4">
                    <div class="text-right">
                      <input type="tel" class="btn inputCvv cvvMask"
                        placeholder="CVV *" v-model="card[index].cvv" maxlength="4"
                        @keydown="isNumber" @focus="updateError('cvv', scard)"
                        @blur="CVVValidator" :ref="`${scard.card_token}`"
                        :class="[ error['cvv']['status'] && scard.card_token == isin ? 'error' : scard.card_token == isin ? 'card-selection' : 'card-default' ]"
                        style="background-color:#fff; margin-top:-8px; color:#464a4c; border-radius: 4px;"/>
                    </div>
                    </div>
                </div>
              </div>
              <div class="item1 radio-item col-1">
                <input :id="scard.card_number" class="collapsepadding" type="radio" name="radio" v-model="isin" :value="scard.card_token" @change="updatecardSelection(scard.card_number)">
                <label :for="scard.card_number"></label>
                <!--<span class="checkmark"></span>-->
              </div>
          </div>
          </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  var $ = require('jquery')
  window.jQuery = $

  import {BankInfo} from './../../components/payment/PaymentConstants.js'
  import * as CardValidator from 'card-validator'
  import CardInfo from 'card-info'

  const exceptionKeys = [32, 13, 8, 37, 38, 39, 40]
  export default {
    props: ['cards', 'setPayMethod', 'payopt', 'buyNowMobile'],
    name: 'savedCard',

    data () {
      return {
        card: this.cards.map(() => ({ cvv: '' })),
        savedCards: this.cards,
        numberLength: 16,
        bankLogo: [],
        cvv: '',
        cvvLength: 3,
        errorMessage: [],
        isin: '',
        error: {
          cvv: {
            status: false,
            message: 'Invalid CVV'
          }
        },
        lastVisitedPayment: '',
        canClick: false,
        openPaymentMethod: null,
        staticImg: process.env.STATIC_IMG_SERVER2
      }
    },
    validators: {
    },
    methods: {
      updateError (field, card) {
        if (card) {
          this.isin = card.card_token
          this.updatecardSelection(card.card_number)
        }
        this.card.cvv = ''
        this.error[field].status = false
        this.errorText = Object.values(this.errorMessage)[Object.values(this.errorMessage).length - 1]
        delete this.errorMessage[field]
      },
      setCardLogo () {
        for (var i = 0; i < this.cards.length; i++) {
          this.bankLogo[i] = BankInfo.get(this.cards[i].card_isin) // Gets the brand info for card number
        }
      },
      cardValidator () {
        let dirtyNumber = ('' + this.card.number).replace(/\s/g, '')
        let cardInfo = new CardInfo(dirtyNumber)
        this.cvvLength = cardInfo.codeLength
      },
      cardInfoHandler () {
        const selectedCard = this.setCard()[0]
        let dirtyNumber = ('' + selectedCard.card_isin).replace(/\s/g, '')
        let cardInfo = new CardInfo(dirtyNumber)
        this.cvvLength = cardInfo.codeLength ? cardInfo.codeLength : 3
        this.card.forEach(element => {
          element.cvv = ''
        })
      },
      setCard () {
        const cardSelected = this.cards.filter((item, index) => {
          if (item.card_token === this.isin) {
            item.index = index
            return item
          }
        })
        return cardSelected
      },
      CVVValidator () {
        const selectedCard = this.setCard()[0]
        this.error.cvv.status = selectedCard && this.card[selectedCard.index].cvv.toString().length < this.cvvLength
        this.errorMessage['cvv'] = selectedCard && this.card[selectedCard.index].cvv.toString().length !== this.cvvLength ? this.error.cvv.message : ''
        if (this.error.cvv.status || this.errorMessage['cvv']) {
          return true
        }
      },
      makeCard () {
        const selectedCard = this.setCard()[0]
        var obj = Object.assign({}, selectedCard)
        let number = obj.number ? obj.number : obj.card_number
        obj.card_number = number.replace(/\s/g, '')
        obj.cvv = this.card[selectedCard.index].cvv
        obj.card_token = selectedCard.card_token
        let cardInfo = new CardInfo(obj.card_number)
        this.numberLength = cardInfo.numberLengths
        obj.valid = this.valid && (this.numberLength.includes(obj.card_number.length))
        return obj
      },
      isNumber (evt) {
        evt = evt || window.event
        let charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105))) && exceptionKeys.indexOf(charCode) === -1) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      updatecardSelection: function (id) {
        this.cardInfoHandler()
        this.checkOpenedPaymentOption()
        if (this.lastVisitedPayment && this.lastVisitedPayment.length > 0 && this.canClick) {
          let domPaymentActive = document.getElementById(this.lastVisitedPayment)
          if (domPaymentActive && domPaymentActive.children && domPaymentActive.children.length > 0) {
            domPaymentActive.children[0].click()
            this.lastVisitedPayment = ''
            this.canClick = false
            this.openPaymentMethod = null
            document.getElementById(`${id}`).click()
          }
        }
        this.setPayMethod('sc')
        let nonRadioPayArr = ['cod', 'prepaid', 'cred', 'dcc']
        if (nonRadioPayArr.indexOf(this.payopt) === -1) {
          this.$store.commit('GTAG_EVENT', {eventName: 'PAYMENT_METHOD_SELECT',
            payload: {
              type: this.$parent.getPaymentName(this.$parent.payopt),
              method: (this.makeCard().card_type || 'NA')
            }}
          )
        }
      },
      checkOpenedPaymentOption: function () {
        let domVal = document.querySelectorAll('.payment.collapse.show')
        if (domVal && domVal.length > 0) {
          this.lastVisitedPayment = domVal[0].getAttribute('aria-labelledby')
          this.canClick = true
          this.openPaymentMethod = this.lastVisitedPayment
        } else {
          this.canClick = false
          this.lastVisitedPayment = ''
          this.openPaymentMethod = null
        }
      }
    },
    created: function () {
      this.setCardLogo()
      // this.setPayMethod('sc')
    },
    updated: function () {
      // const selectedCard = this.setCard()[0]
      // console.log(selectedCard)
      // var obj = Object.assign({}, selectedCard)
      // obj.card_number = obj.card_number.replace(/\s/g, '')
      // obj.cvv = this.card[selectedCard.index].cvv
      // let cardInfo = new CardInfo(obj.number)
      // this.numberLength = cardInfo.numberLengths
      // obj.valid = this.valid && (this.numberLength.includes(obj.number.length))
      // console.log(obj)
    },
    watch: {
      payopt () {
        if (this.payopt !== 'sc') {
          this.isin = ''
          this.card.forEach(element => {
            element.cvv = ''
          })
          let domVal = document.querySelectorAll('.card-header.active-tab')
          if (domVal && domVal.length > 0) {
            this.lastVisitedPayment = document.querySelectorAll('.card-header.active-tab')[0].getAttribute('id')
            this.canClick = true
          }
          if (this.payopt === 'upi' && this.openPaymentMethod !== 'headingFive' && this.$parent.$refs.upiSelector) {
            this.$parent.$refs.upiSelector._data.gPaySelected = false
            this.$parent.$refs.upiSelector._data.payTmSelected = false
            this.$parent.$refs.upiSelector._data.upi.name = '<>'
          }
          if (this.payopt === 'nb') {
            this.$parent.$refs.netBankingInput._data.bank = '<>'
          }
        }
      },
      'card': {
        handler () {
          const selectedCard = this.setCard()
          if (selectedCard && selectedCard.length) {
            this.valid = (
              CardValidator.cvv(this.card[selectedCard[0].index].cvv, this.cvvLength).isValid && true
            )
          }
        },
        deep: true
      },
      isin (val) {
        this.$refs && this.$refs[val] && this.$refs[val][0] && this.$refs[val][0].focus()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 6px;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  color: #666;
  font-weight: normal;
}
.image-wrapper {
  border:0;
  border-radius: 50%;
  padding:0px;
  margin: 0;
  width: 40px;
  height:40px;
  margin-right: 18px;
  box-shadow: 0 0 5px #d9caca;           
  overflow: hidden;
}
.font-semibold{
  font-weight: 600;
  -webkit-text-stroke: 0.30px #ffffff;
  -webkit-font-smoothing: antialiased;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 18px;
  height: 18px;
  border-radius: 11px;
  border: 2px solid #ccc;;
  background-color: transparent;
  cursor: pointer;
}
.radio-item input[type=radio]:checked + label:before {
  border: 2px solid #117a7a !important;
}

.radio-item input[type=radio]:checked + label:after {
  border-radius: 11px;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 9px;
  left: 10px;
  content: " ";
  display: block;
  background: #117a7a;
  cursor: pointer;
}

  .grid-container {
    display: grid;
    grid-template-columns: 2% 8% auto auto;
    grid-gap: 10px;
    padding: 10px;
  }

  .cardwrap658{
    display: flex;
    justify-content: space-between;
    padding: 10px 7px;
  }

  .cardleft69{display: flex; align-items: center;}
  .cardright69{display:flex; align-items: center;}
  .item2{ 
   
     border:0;
    border-radius: 50%;
    padding:0px;
    margin: 0;
    width: 40px;
    height:40px;
    margin-right: 18px;
    box-shadow: 0 0 5px #d9caca;           
    overflow: hidden;
    display: flex;
  }
.item1{position: relative;}

  

  .inputCvv {
    width: 100px;
  }
  .cvvMask {
    -webkit-text-security: disc;
    -webkit-user-select: text !important;
  }
  .error {
    border-color: #eb3e25 !important;
  }
  .card-selection {
    border-color: #117a7a !important;
  }
  .card-default {
    border-color: #cccccc !important;
  }
  .brandLogo {
    margin-top: 19%;
  }

  /* The container */
  .containor {
    display: block;
    margin-bottom: 0;
  }

  /* Hide the browser's default radio button */
  .collapsepadding {
    display: none;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    bottom: -2px;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #ccc;
    border-radius: 50%;
  }

  /* On mouse-over, change cu83%rsor */
  .containor:hover {
    cursor: pointer;
  }

  /* When the radio button is checked, add a red background */
  .containor input:checked ~ .checkmark {
    background-color: red;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
  }

  /* Show the indicator (dot/circle) when checked */
  .containor input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .containor .checkmark:after {
    top: 3px;
    left: 3px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: white;
  }
  /* buy now mobile */
  .address-cards {
    overflow-x: auto;
  }
  .addCard {
    border-radius: 5px;
    border: 1px solid rgb(138, 138, 138);
    margin-left: 1rem;
  }
  .addCard-active {
    border: 1px solid rgb(1, 145, 145);
  }
  .address-cards {
    overflow-x: auto;
  }
  .item99{ 
    border:0;
    border-radius: 50%;
    padding:0px;
    margin: 0;
    width: 25px;
    height:25px;
    box-shadow: 0 0 5px #6d6d6d;           
    overflow: hidden;
    display: flex;
  }
  .inputCvv2 {
    width: 35px;
  }
  .addCard input[type=password] {
      box-sizing: border-box;
      padding: 0;
      font-size: x-small;
      height: 1.5rem;
      border-radius: 5px;
  }
  .paymentSprite-visa {
    width: 40px;
    height: 25px;
  }
  .item3{font-size: 13px;}
  @media screen and (max-width: 479px) {
    .item3{font-size: 11px;}

    .grid-container {
      display: grid;
      grid-template-columns: 6% 15% auto auto;
      grid-gap: 10px;
      padding: 0px;
    }
    .radio-item input[type=radio]:checked + label:after {
      left: 9px;
    }
    .inputCvv {
      width: 75px;
    }
    .card {
      border-left:none;
      border-right:none;
      border-bottom: none;
    }
    .saved-cards-wrap:last-child  {
      border-bottom: 1px solid rgba(0,0,0,.125);
    }
  }
</style>



// WEBPACK FOOTER //
// saveCards.vue?a288425c